// frontend/src/main.jsx
// FRONTEND_CODE_VERSION = "v1.0.1"

// Import console filter first to suppress browser extension errors
import "./utils/consoleFilter.js";

import React, { Suspense } from "react"; // Import Suspense
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.jsx";
import "./index.css";
import { AuthProvider } from "./contexts/AuthContext.jsx";
import NotificationProvider from "./contexts/NotificationContext.jsx";
import { RealTimeProvider } from "./contexts/RealTimeContext.jsx";
import { ProgressiveResultsProvider } from "./contexts/ProgressiveResultsContext.jsx";
import { TrackingProvider } from "./contexts/TrackingContext.jsx";
import "./i18n"; // Initialize i18next (must be imported before App)

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <Suspense fallback="Loading...">
        <AuthProvider key="auth-provider-root">
          <TrackingProvider>
            <NotificationProvider>
              <RealTimeProvider>
                <ProgressiveResultsProvider>
                  <App />
                </ProgressiveResultsProvider>
              </RealTimeProvider>
            </NotificationProvider>
          </TrackingProvider>
        </AuthProvider>
      </Suspense>
    </HelmetProvider>
  </React.StrictMode>
);
